import { render, staticRenderFns } from "./salida-detalle.vue?vue&type=template&id=05d87ee4"
import script from "./salida-detalle.vue?vue&type=script&lang=js"
export * from "./salida-detalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports